import { useCustomerSupport } from './useCustomerSupport';

// TODO we may have more logic in this component in future

const CustomerSupport = () => {
  useCustomerSupport();
  return null;
};

export default CustomerSupport;
